(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  class SearchResultsLoader extends HTMLElement {
    connectedCallback() {
      this.setupLoadMore();
      this.setupInfiniteScroll();
    }

    setupLoadMore() {
      const loadMoreContainer = this.querySelector('.orr-load-more-container');
      const productGrid = this.querySelector('#product-grid');

      if (!loadMoreContainer || !productGrid) return;

      loadMoreContainer.addEventListener('click', (e) => {
        const loadMoreBtn = e.target.closest('#load-more-btn');
        if (!loadMoreBtn) return;

        e.preventDefault();
        const nextUrl = productGrid.getAttribute('data-next-url');
        if (!nextUrl) return;

        loadMoreBtn.classList.add('loading');

        fetch(nextUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const parser = new DOMParser();
            const html = parser.parseFromString(responseText, 'text/html');
            const newGrid = html.querySelector('#product-grid');
            const newProducts = newGrid.querySelectorAll('.product-card-wrapper');

            // Append new products
            newProducts.forEach((item) => {
              productGrid.appendChild(item);
            });

            // Update next URL
            const newNextUrl = newGrid.getAttribute('data-next-url');
            if (newNextUrl) {
              productGrid.setAttribute('data-next-url', newNextUrl);
              loadMoreBtn.classList.remove('loading');
            } else {
              loadMoreBtn.style.display = 'none';
            }

            // Update URL without reload
            history.pushState({}, '', nextUrl);
          })
          .catch((err) => {
            console.error('Error loading more products:', err);
            loadMoreBtn.classList.remove('loading');
          });
      });
    }

    setupInfiniteScroll() {
      const loadMoreContainer = this.querySelector('.orr-load-more-container');
      const productGrid = this.querySelector('#product-grid');

      if (!loadMoreContainer || !productGrid) return;

      const setupObserver = () => {
        if (window.innerWidth <= 1023) {
          if (!this.infiniteScrollObserver) {
            this.infiniteScrollObserver = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    const loadMoreBtn = this.querySelector('#load-more-btn');
                    const nextUrl = productGrid.getAttribute('data-next-url');
                    if (nextUrl && loadMoreBtn && !loadMoreBtn.classList.contains('loading')) {
                      loadMoreBtn.click();
                    }
                  }
                });
              },
              {
                rootMargin: '0px 0px 400px 0px',
                threshold: 0.1,
              }
            );
            this.infiniteScrollObserver.observe(loadMoreContainer);
          }
        } else {
          if (this.infiniteScrollObserver) {
            this.infiniteScrollObserver.disconnect();
            this.infiniteScrollObserver = null;
          }
        }
      };

      setupObserver();

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(setupObserver, 200);
      });
    }
  }

  if (!customElements.get('search-results-loader')) {
    customElements.define('search-results-loader', SearchResultsLoader);
  }

  } catch(e) { console.error(e); }
})();
})();
